export default __webpack_public_path__ + "static/media/Mark-4-HUD-06.1e3dcd6c.jpg";